import { render, staticRenderFns } from "./TestimonialInvoicePopUp.vue?vue&type=template&id=18919ca0&scoped=true&"
import script from "./TestimonialInvoicePopUp.vue?vue&type=script&lang=js&"
export * from "./TestimonialInvoicePopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18919ca0",
  null
  
)

export default component.exports